import $ from "jquery";
import axios from "axios";

const URL = '/rest/user/license/change-quantity';
const ERROR_CLASS = 'has-error';
const UNKNOWN_ERROR = 'Unknown error';

const parse = json => {
    try {
        return JSON.parse(json);
    } catch (error) {
        return null;
    }
}

const getErrorMessage = data => {
    const json = parse(data);

    if (!json && typeof data === 'string') {
        return data;
    }

    if (!json) {
        return UNKNOWN_ERROR;
    }

    const messages = Object.values(json);

    if (messages.length === 0) {
        return UNKNOWN_ERROR;
    }

    if (messages[0] instanceof String) {
        return messages[0];
    }

    if (!Array.isArray(messages[0])) {
        return UNKNOWN_ERROR;
    }

    return messages[0][0]
}

export const handleQuantityField = () => {
    $('#license-quantity').on('change paste keyup', function () {
        if ($(this).val().length === 0) {
            return;
        }

        const quantity = $(this).val();
        const licenseId = $(this).data('license-id');
        const licensePrice = parseInt(quantity) * parseInt($(this).data('price'));

        axios.post(URL, {licenseId: licenseId, quantity: quantity})
            .then((response) => {
                $(this).parents('.form-group').removeClass(ERROR_CLASS);
                $(this).parents('.form-group').find('.error-label').html('');

                $(this).val(response.data.data);
                $('#current-price').text(licensePrice);
            }).catch((error) => {
                console.log(error);
            $(this).parents('.form-group').addClass(ERROR_CLASS);
            $(this).parents('.form-group').find('.error-label').html(
                getErrorMessage(error.response.data.message),
            );
        });
    });
};